// extracted by mini-css-extract-plugin
export var testLog = "test-log-module--testLog--2e275";
export var testLogTitle = "test-log-module--testLogTitle--d66da";